<template>
  <div class="master">
    <div class="fixed-top row top-nav">
      <b-navbar toggleable="sm" type="dark" variant="gray-950" class="col" style="padding-left: 35px;">
  <img src="../../static/image/logo_Getac.svg" style="height: 1.429rem;" alt="Getac Logo" />
        <span class="bg-white mx-3" style="width:2px; height: 1.786rem;"></span>
        <span v-if="prdEnv()" class="text-white system-name">ETO NRE System Ver {{$session.get('version')}}</span>
        <span v-else class="text-white system-name">ETO NRE System Ver {{$session.get('version')}} - {{$session.get('mode')}}</span>



        <b-navbar-nav class="ml-auto align-items-center mr-3">

          <b-nav-item-dropdown class="ml-auto align-items-center">
            <template #button-content>
        <img src="../../static/image/icon_user.svg" style="height: 3.28rem" alt="User Icon" />
              <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_name')}}</b-nav-text>
              <!--
                    <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_roles')}}</b-nav-text>
                    <b-nav-text class="text-white mr-3 user-name">{{$session.get('user_functions')}}</b-nav-text>
              -->

            </template>
            <b-dropdown-item href="#" @click="signout">Log Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>

    <!--#region -- NAV for FTIE features ---->
    <div style="padding-top: 70px;">
      <b-nav tabs align="left" style="font-size: 18px;">
        <b-nav-item to="/home"
                    style="padding-top: 10px;">
          <img src="../../static/image/icon_home_#F77530.svg" style="width: 28px; padding-bottom: 2px;" alt="Home Icon" />
          Home
        </b-nav-item>
        <!--

                        <b-nav-item style="padding-top: 12px;" to="/ftie/ftie-dashboard" exact exact-active-class="active">List</b-nav-item>
                <b-nav-item style="padding-top: 12px;"
                            to="/ftie/ftie-page-dashboard"
                            exact exact-active-class="active">
                  Page
                </b-nav-item>
        -->

      </b-nav>
    </div>
    <!---#endregion NAV ---->
    <div v-if="loginUser">
      <div class="p-4">
        <div v-if="!loginUser" class="position-absolute d-flex" style="left: 0;right: 0;top: 4.286rem;bottom: 0;">
          <div class="m-auto" style="min-width: 15rem">
            <div class="h3 text-danger">
              Missing data, please contact system administrator. Alice Lee: alice.cy.lee@getac.com.tw
            </div>
          </div>
        </div>

        <router-view v-else
                     ref="child"
                     :readOnly="readOnly"
                     :loginUser="loginUser"
                     :data="$data"
                     :serverEnv="serverEnv"
                     @reload="reload" />

      </div>
    </div>
  </div>
</template>
<script>
  import * as moment from 'moment/moment';
  export default {
    name: 'es-master-page',
    props: {
      stageKey: {
        type: String,
        default: ''
      },
      stageApiBase: {
        type: String,
        default: ''
      },
      stageApiName: {
        type: String,
        default: ''
      },
      currencyDisabled: {
        type: Boolean,
        default: true
      }
    },
    data: () => {
      return {
        currencyTmp: null,
        nreData: null,
        ftieData: null,
        tmpData: null,

        frontEndUrlToUse: null,
      };
    },
    created() {
      let self = this;

      let callback = () => {
        //self.loadProjectProposalFileSetting();


        if (!self.readOnly) {
          console.log("!self.readOnly!");
        }
        /*
        else if (self.stageNumber === '30') {
          self.loadHqSalesWatch();
        }
        else if (self.stageNumber === '40') {
          self.loadMailGroupSetting();
          self.loadSaHeadWatch()
        }
        */

        //endregion

        //#region 未儲存提示

        $(window).on('beforeunload', function () {
          if (!self.readOnly && JSON.stringify(self.nreData) !== JSON.stringify(self.tmpData)) {
            return "You have made changes on this page that you have not yet confirmed.\nIf you navigate away from this page you will lose your unsaved changes";
          }
        });

        //#endregion
      };

      self.reload(callback);

    },
    computed: {
      readOnly() {
        return false;
        //return _.get(this.nreData, 'action_disabled', true);
      },
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      serverEnv() {
        return _.get(this.$store, 'state.env', null);
      },
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },

      //#region -- Permission --
      checkLoggedIn() {
        let self = this;
        let result = true;
        if (_.trim(self.loginUser) === '') result = false;
        self.frontEndUrlToUse = this.$session.get('frontEndUrlToUse');
        return result;
      },
      //#endregion

      signout() {

        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            window.location = this.$session.get('frontEndUrlToUse') + '/azure-login';
          })
      },
      reload(callback, keyPath) {
        let self = this;
        let nreData = null;
        let ftie_id = encodeURIComponent(self.$route.params.ftie_id);
        let real_sku_no = encodeURIComponent(self.$route.params.real_sku_no);
        let baseUrl = _.trim(self.$root.baseUrl);
        let params = {
          username: self.loginUser
        };

        eventHub.$emit('loading', true);

        if (self.checkLoggedIn() && _.isFunction(callback)) {
          eventHub.$emit('loading', false);
          callback();
        }
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EsMasterPage.vue